import React from 'react';
import { head, isEmpty } from 'lodash';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    r_check_star,
    r_heart,
    r_globe,
    r_repeat,
    r_industry,
    l_users,
    r_lightning,
    s_calendar,
    r_times_circle,
} from '@fiverr-private/icons';
import { DATETIME_ELEMENT_STYLES } from '../../../contexts/LocalizationContext';
import { highlightTypes } from '../constants';

const T_PREFIX = 'experts.highlights';

/**
 * get contant styles
 * @desc this method returns the content of the highlight according to highlight type
 * @param {string} type
 * @param {object} additionalData
 * @param {function} dateTimeFormat
 * @returns {object} - includes the className style and content
 */
export const getHighlightContent = (type, additionalData, dateTimeFormat) => {
    switch (type) {
        case highlightTypes.proVerified: {
            return {
                icon: r_check_star,
                text: <I18n k={`${T_PREFIX}.pro`} />,
            };
        }
        case highlightTypes.saved: {
            const { userId } = getContext();
            const isCurrentUser = additionalData?.savedBy?.id === userId;
            return {
                icon: r_heart,
                text: isCurrentUser ? (
                    <I18n k={`${T_PREFIX}.saved_by_you`} />
                ) : (
                    <I18n k={`${T_PREFIX}.saved`} params={{ username: additionalData?.savedBy?.fullName }} />
                ),
            };
        }
        case highlightTypes.language: {
            const { locale } = getContext();
            return {
                icon: r_globe,
                text: (
                    <I18n
                        k={`${T_PREFIX}.language`}
                        params={{
                            language: translate(`languages.codes.${additionalData?.language}`, { $scope: locale }),
                        }}
                    />
                ),
            };
        }
        case highlightTypes.loyalty: {
            return {
                icon: r_repeat,
                text: <I18n k={`${T_PREFIX}.loyalty`} />,
            };
        }
        case highlightTypes.matchingIndustries: {
            return {
                icon: r_industry,
                text: (
                    <I18n
                        k={`${T_PREFIX}.matching_industries`}
                        params={{ number: additionalData.buyerCount, industry: additionalData.title }}
                    />
                ),
            };
        }
        case highlightTypes.collaborate: {
            const { userId } = getContext();
            let isCurrentUser = false;
            const collaborateArr = additionalData.collaborateData;
            collaborateArr.forEach((element, index) => {
                if (element.buyer_id === userId) {
                    isCurrentUser = true;
                    collaborateArr.splice(index, 1);
                }
            });
            let presentedUsername;
            if (!isCurrentUser) {
                presentedUsername = head(collaborateArr).full_name;
                collaborateArr.shift();
            }
            return {
                icon: l_users,
                text: (
                    <span>
                        {isCurrentUser ? (
                            <I18n k={`${T_PREFIX}.collaborate_with_you`} />
                        ) : (
                            <I18n k={`${T_PREFIX}.collaborate`} params={{ username: presentedUsername }} />
                        )}
                        {!isEmpty(collaborateArr) && (
                            <>
                                &nbsp;
                                <I18n k={`${T_PREFIX}.n_more`} params={{ number: collaborateArr.length }} />
                            </>
                        )}
                    </span>
                ),
            };
        }
        case highlightTypes.responsive: {
            return {
                icon: r_lightning,
                text: <I18n k={`${T_PREFIX}.responsive`} />,
            };
        }
        case highlightTypes.sellerOnVacation: {
            const endsAt = dateTimeFormat(new Date(additionalData.endsAt * 1000), {
                year: DATETIME_ELEMENT_STYLES.NUMERIC,
                month: DATETIME_ELEMENT_STYLES.SHORT,
                day: DATETIME_ELEMENT_STYLES.TWO_DIGIT,
            });
            return {
                icon: s_calendar,
                text: <I18n k={`${T_PREFIX}.seller_on_vacation`} params={{ date: endsAt }} />,
            };
        }
        case highlightTypes.inactiveSeller: {
            return {
                icon: r_times_circle,
                text: <I18n k={`${T_PREFIX}.inactive_seller`} />,
            };
        }
        default: {
            return {
                content: '',
            };
        }
    }
};
